var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{on:{"after-enter":_vm.onComplete,"after-leave":_vm.onComplete,"beforeLeave":_vm.onLeave}},[(!!_vm.shownBar)?_c('div',{staticClass:"notification-bar-container"},[_c('transition',[_c('layout-notification-bar',{key:_vm.shownBar.id,attrs:{"content":_vm.shownBar}})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }